export const GET_ALL_TRANSACTION = "GET_ALL_TRANSACTION"
export const GET_ALL_TRANSACTION_SUCCESS = "GET_ALL_TRANSACTION_SUCCESS"
export const GET_ALL_TRANSACTION_FAIL = "GET_ALL_TRANSACTION_FAIL"


export const GET_PARTICULAR_TRANSACTION = "GET_PARTICULAR_TRANSACTION"
export const GET_PARTICULAR_TRANSACTION_SUCCESS = "GET_PARTICULAR_TRANSACTION_SUCCESS"
export const GET_PARTICULAR_TRANSACTION_FAIL = "GET_PARTICULAR_TRANSACTION_FAIL"

export const ADD_TRANSACTION = "ADD_TRANSACTION"
export const ADD_TRANSACTION_SUCCESS = "ADD_TRANSACTION_SUCCESS"
export const ADD_TRANSACTION_FAIL = "ADD_TRANSACTION_FAIL"



export const GET_ALL_TRANSATIONS_FROM_USER_ID = "GET_ALL_TRANSATIONS_FROM_USER_ID"
export const GET_ALL_TRANSATIONS_FROM_USER_ID_SUCCESS = "GET_ALL_TRANSATIONS_FROM_USER_ID_SUCCESS"
export const GET_ALL_TRANSATIONS_FROM_USER_ID_FAIL = "GET_ALL_TRANSATIONS_FROM_USER_ID_FAIL"

export const GET_USER_EARNING_FROM_USER_ID = "GET_USER_EARNING_FROM_USER_ID"
export const GET_USER_EARNING_FROM_USER_ID_SUCCESS = "GET_USER_EARNING_FROM_USER_ID_SUCCESS"
export const GET_USER_EARNING_FROM_USER_ID_FAIL = "GET_USER_EARNING_FROM_USER_ID_FAIL"